import { DataPermissionEntityModel } from "src/store/models/entity/dataPermission/entity";
import { DataPermissionHelperModel } from "src/store/models/entity/dataPermission/helper";

export const encooDataPermissionModels = {
  entity: DataPermissionEntityModel,
  helper: DataPermissionHelperModel,
};
